// The first-visit popup (snippets/welcome-popup.liquid). It opens after a
// moment for anyone who hasn't seen it in the last 30 days (once they've
// answered the cookie banner, which would otherwise cover it on a phone),
// and the sign-up
// goes in without leaving the page (if Shopify wants a captcha ticked on a
// page of its own, the form is sent the ordinary way so it can show it).
//
// It tells dotcom how it goes, as a 'dotcom:welcome' event on document with
// the state in event.detail ('open', 'nah' or 'signed-up'), and in
// window.DOTCOM_WELCOME for when he turns up after it's opened. It also takes
// the page's one deal mention (window.DOTCOM_DEAL_SLOT), since it states the
// deals, so dotcom doesn't repeat them.
(function () {
  var STORAGE_KEY = 'welcomePopupDismissedUntil';

  function tell(state) {
    window.DOTCOM_WELCOME = state;
    document.dispatchEvent(new CustomEvent('dotcom:welcome', { detail: state }));
  }

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('WelcomePopup');
    if (!popup) return;

    var dialog = popup.querySelector('.welcome-popup__dialog');
    var form = document.getElementById('WelcomePopupForm');
    var error = popup.querySelector('.welcome-popup__error');
    var buttons = popup.querySelectorAll('.welcome-popup__button');
    var reappearDays = Number(popup.dataset.reappearDays || 30);
    var openedBy = null;

    function isDismissed() {
      try {
        var until = window.localStorage.getItem(STORAGE_KEY);
        return !!until && Number(until) > Date.now();
      } catch (e) {
        return false;
      }
    }

    function dismissForReappearWindow() {
      try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now() + reappearDays * 24 * 60 * 60 * 1000));
      } catch (e) {}
    }

    function openPopup() {
      document.body.classList.add('welcome-popup-open');
      popup.setAttribute('open', '');
      openedBy = document.activeElement;
      if (typeof trapFocus === 'function') trapFocus(popup, dialog);
      window.DOTCOM_DEAL_SLOT = window.DOTCOM_DEAL_SLOT || 'popup';
      tell('open');
    }

    function closePopup(state) {
      if (!popup.hasAttribute('open')) return;
      document.body.classList.remove('welcome-popup-open');
      popup.removeAttribute('open');
      dismissForReappearWindow();
      if (typeof removeTrapFocus === 'function') removeTrapFocus(openedBy);
      tell(state);
    }

    function showError(text) {
      error.textContent = text;
      error.hidden = false;
      busy(false);
    }

    popup.querySelectorAll('[data-welcome-nah]').forEach(function (button) {
      button.addEventListener('click', function () {
        closePopup('nah');
      });
    });
    popup.addEventListener('click', function (event) {
      if (event.target === popup) closePopup('nah');
    });
    popup.addEventListener('keyup', function (event) {
      if (event.code === 'Escape') closePopup('nah');
    });

    // Sent into a hidden frame, so the page stays put. Shopify guards sign-ups
    // with an invisible hCaptcha: its script takes over the submit, gets a
    // token (asking them to tick a box, if it must) and then sends the form
    // the ordinary way, which would otherwise reload the page. Shopify answers
    // with the page again, with customer_posted=true or the form's errors in
    // it. The frame doesn't run that page's scripts, it's only read.
    var FAILED = 'That didn’t go through. Check the email and try again.';
    var frame = document.createElement('iframe');
    frame.name = 'WelcomePopupFrame';
    frame.hidden = true;
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('sandbox', 'allow-same-origin');
    popup.appendChild(frame);
    form.target = frame.name;
    var sending = false;
    var giveUp = 0;

    function busy(on) {
      sending = on;
      for (var i = 0; i < buttons.length; i++) buttons[i].disabled = on;
      window.clearTimeout(giveUp);
      // (a captcha box left unticked never comes back)
      if (on) giveUp = window.setTimeout(function () {
        if (sending) showError(FAILED);
      }, 45000);
    }

    // where it couldn't be done in the frame: the ordinary way after all
    function sendForReal() {
      form.removeAttribute('target');
      form.submit();
    }

    form.addEventListener('submit', function (event) {
      error.hidden = true;
      busy(true);
      // Shopify's script holds back a sign-up sent before its captcha is
      // ready (straight after an autofill, say), so it goes once it is
      window.setTimeout(function () {
        if (!event.defaultPrevented || form.hasAttribute('data-hcaptcha-bound')) return;
        var tries = 0;
        var wait = window.setInterval(function () {
          if (form.hasAttribute('data-hcaptcha-bound')) {
            window.clearInterval(wait);
            form.submit();
          } else if (++tries > 40) {
            window.clearInterval(wait);
            showError(FAILED);
          }
        }, 200);
      }, 0);
    });

    frame.addEventListener('load', function () {
      var url;
      var page;
      try {
        url = frame.contentWindow.location.href;
        page = frame.contentDocument;
      } catch (e) {
        // somewhere it can't be read (another site)
        if (sending) sendForReal();
        return;
      }
      if (!url || url === 'about:blank' || !page) return;
      // Shopify wants a captcha ticked on a page of its own
      if (/\/challenge/.test(url)) {
        sendForReal();
        return;
      }
      var sent = page.getElementById('WelcomePopup');
      if (/customer_posted=true/.test(url) || (sent && sent.hasAttribute('data-just-subscribed'))) {
        busy(false);
        closePopup('signed-up');
      } else {
        var message = sent && sent.querySelector('.welcome-popup__error');
        showError((message && message.textContent.trim()) || FAILED);
      }
      frame.src = 'about:blank';
    });

    // back from signing up the ordinary way, or with something to fix
    if (popup.hasAttribute('data-just-subscribed')) {
      dismissForReappearWindow();
      tell('signed-up');
      return;
    }
    if (popup.hasAttribute('data-errors')) {
      openPopup();
      return;
    }

    // one thing at a time: the cookie banner first
    function bannerUp() {
      var banner = document.getElementById('shopify-pc__banner');
      return !!banner && banner.getClientRects().length > 0 && getComputedStyle(banner).visibility !== 'hidden';
    }
    function openWhenClear() {
      if (bannerUp()) window.setTimeout(openWhenClear, 600);
      else openPopup();
    }
    // (not on the page for unsubscribing from emails, of all places, nor on
    // the page-not-found page, where dotcom's busy being lost)
    var elsewhere = /\/account\/unsubscribe(\/|$)/.test(location.pathname) || !!document.querySelector('.template-404');
    if (!isDismissed() && !elsewhere) {
      window.setTimeout(openWhenClear, 1500);
    }
  });
})();
